import { PromotionPlacementZod } from '@onr/schema'

import { type FirestorePromotionDocument } from '@/state/promotions/FirestorePromotionDocument'

export const toFormValues = (state?: FirestorePromotionDocument) => ({
  partnerName: '',
  title: '',
  targetUrl: '',
  active: true,
  creativeUrls: {},
  ...state,
  placements: Object.fromEntries(
    PromotionPlacementZod.options.map((placement) => [placement, state?.placements?.includes(placement) ?? false])
  ),
})
